module.exports = __webpack_public_path__ + "img/consumption_purple.0b97f773.png";